
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"201","height":"70","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.71 19.694L5 45.552l.447 11.987 7.413 2.572 9.402-11.575 8.756-20.645m10.374 5.378l-3.822 22.05 1.092 9.143L61.594 65M43.03 51.017l17.472-1.614m-16.38-12.907h10.92l9.282-1.614m32.213 0l-14.195-2.689-9.828 1.076v13.445l21.84 2.69 3.822 8.604L83.433 65l-12.558-6.992m59.513-33.882l-16.38 1.076-8.19 5.916 1.638 8.067 22.932-1.076 6.552 11.294-10.92 3.765-19.11-.538m30.03-37.647l6.006 19.9 9.282 11.831 20.747-6.453m-26.207-10.219l18.017-2.151m-25.115-12.908l26.753-1.613M172.976 1l2.184 23.126 5.46 15.059h14.196L197 27.89","stroke":"#7070FF","stroke-width":"8"}})])
          )
        }
      }
    